// extracted by mini-css-extract-plugin
module.exports = {"price":"_927a99ad28--price--al3qg","marketing-price":"_927a99ad28--marketing-price--PGAB8","total":"_927a99ad28--total--l7Sjv"};